import angular from 'angular';
import emailIconField from './emailIconField';
import './style.scss';

export default angular
  .module('emailIconField', [])
  .component('emailIconField', emailIconField).name;
